<template lang="html">
  <!--
  Component to render <button> element
  - Accepts the following properties:
  [id, type, text, disabled, borderStyle, data]

  type options: neutral, brand, outline-brand, destructive,
                text-destructive, success, inverse
  borderStyle options: left, center, right

  - Accepts callback property:
  [on-button-click]

  @example

  <button-element
    ref="button123"
    id="button123"
    type="brand"
    text="Accept"
    @on-button-click="onButtonElementClick"
  />
  -->

  <section class="button-element">
    <button
      :id="id"
      :class="['m-button', type, borderClassStyle]"
      :disabled="disabled"
      v-on:click="onButtonClick"
    >
      {{ text }}
    </button>
  </section>
</template>

<script lang="js">

  export default  {
    name: "button-element",
    props: {
      id: {
        type: String
      },
      text: {
        type: String,
        default: "Button"
      },
      type: {
        type: String
      },
      borderStyle: {
        type: String
      },
      disabled: {
        type: Boolean
      },
      data: {
        type: Object
      }
    },
    methods: {
      onButtonClick() {
        this.$emit("on-button-click", this.data);
      }
    },
    computed: {
      borderClassStyle() {
        return this.borderStyle? `btn-${this.borderStyle}` : "";
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .button-element {
    display: inline-block;
    .btn-left {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .btn-center {
      border-radius: 0;
    }
    .btn-right {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
</style>
